import React from "react";
import { FREE_SHIPPING_THRESHOLD } from "./FreeShippingBar";

/**
 * Subtotal + set savings + total rendering for the cart drawer footer.
 * Pure presentation — receives all values from the parent.
 */
export const CartTotals = ({ subtotal, setSavings, total, appliedSets }) => (
  <>
    {appliedSets.length > 0 && (
      <div className="mb-4 space-y-1.5" data-testid="cart-set-savings">
        {appliedSets.map(({ set: s, count: n, savings }) => (
          <div key={s.id} className="flex justify-between items-baseline">
            <div>
              <div className="micro-label text-[#1a1814]">✓ {s.name}{n > 1 ? ` × ${n}` : ""}</div>
              <div className="text-[10px] italic text-[#1a1814]/55 mt-0.5">{s.tagline}</div>
            </div>
            <div className="font-serif text-sm text-[#1a1814]">−£{savings.toFixed(2)}</div>
          </div>
        ))}
      </div>
    )}
    <div className="flex justify-between mb-1 micro-label text-[#1a1814]/60">
      <span>Subtotal</span>
      <span>£{subtotal.toFixed(2)}</span>
    </div>
    {setSavings > 0 && (
      <div className="flex justify-between mb-1 micro-label text-[#1a1814]">
        <span>Set savings</span>
        <span>−£{setSavings.toFixed(2)}</span>
      </div>
    )}
    <div className="flex justify-between mb-6 pt-2 border-t border-[#1a1814]/15">
      <div>
        <div className="micro-label text-[#1a1814]/60">Total</div>
        <span className="font-display text-2xl" data-testid="cart-subtotal">£{total.toFixed(2)}</span>
      </div>
      <span className="text-xs text-[#1a1814]/60 self-end text-right leading-tight">
        GBP<br />
        {total >= FREE_SHIPPING_THRESHOLD
          ? "Complimentary UK shipping"
          : "UK shipping £4.95 · Free over £85"}
      </span>
    </div>
  </>
);
